<template>
  <q-dialog
    v-if="preparing"
    :model-value="true"
    persistent
    no-backdrop-dismiss
    no-esc-dismiss
  >
    <q-card class="q-pa-lg" style="min-width: 280px">
      <IphoneTopConfigurationProgress
        overlay
        :loading="true"
        :message="prepareMessage || t('sales.tapToPayPreparingHint')"
      />
      <div class="text-center text-subtitle2 q-mt-md text-weight-medium">
        {{ t('sales.tapToPayPreparingTitle') }}
      </div>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useIphoneTopUiStore } from '@/stores/iphoneTopUi.js'
import IphoneTopConfigurationProgress from '@/components/payments/IphoneTopConfigurationProgress.vue'

const { t } = useI18n()
const iphoneTopUiStore = useIphoneTopUiStore()
const { preparing, prepareMessage } = storeToRefs(iphoneTopUiStore)
</script>
